import { formatDistanceStrict } from "date-fns";

/**
 * GET THE DIFFERENCE DATE FORMAT
 * @param date DATE | NUMBER | STRING
 * @returns FORMATTED DATE STRING
 */
export function getDateDifference(date: string | number | Date) {
  const distance = formatDistanceStrict(new Date(), new Date(date));
  return distance + " ago";
}
/**
 * GET FORMAT BYTES
 * @param bytes
 * @param decimals
 * @returns FORMATTED BYTES STRING
 */
export function formatBytes(bytes: any, decimals = 2) {
  if (bytes === null) return '';

  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * IS TRUTHY VARIABLE
 * @param value
 * @returns Boolean
 */
const truthyValues: (string | boolean)[] = ['true', 'yes', '1', true];

export const isTruthy = (value: unknown): boolean =>
  typeof value === 'string' || typeof value === 'boolean' ? truthyValues.includes(value) : false;


/**
 * GET BOOL VARIABLE
 * @param value
 * @returns Boolean
 */
export const toBool = (value: any) => String(value).toLowerCase() === 'true';

/**
 * TRUNCATE TEXT
 * @returns Boolean
 * @param text
 * @param max
 */
export const truncateText = (text: string, max: number = 50) => text.length > max ? text.slice(0, max) + '…' : text;
